wbApp.controller('HeaderNavigationCtrl', ['$scope', '$modal', '$window', 'activeFeaturesSvc', 'securitySvc', 'urlUtils',
function ($scope, $modal, $window, activeFeaturesSvc, securitySvc, urlUtils) {
    var moreMenu = _.find(mainMenuData, { id: 'More' });
    if (!!moreMenu && !!moreMenu.items) {
        var menuItemForms = _.find(moreMenu.items, { id: 'MenuItemForms' });
        if (!!menuItemForms) {
            menuItemForms.visible = !!activeFeaturesSvc.isClientFormSupportEnabled();
        }
    }

    $scope.menuOptions = {
        dataSource: mainMenuData,
        hideSubmenuOnMouseLeave: false,
        onItemRendered: function(e) {
            if (!!e.itemData && e.itemData.id === "Logout") {
                e.itemElement.addClass("menu-logout");
            }
        },
        onItemClick: function (data) {
            var item = data.itemData;
            if (item.id === "Login") {
                signInDialogPromise.$promise.then(function () {
                    signInDialogPromise.show();
                });
            }
            if (item.id === "Logout") {
                securitySvc.logout();
            }
            if (!!item.navigateUrl) {
                $window.location.href = item.navigateUrl;
            }
        }
    };


    var signInDialogPromise = $modal({
        templateUrl: 'sign-in/sign-in-dialog.html',
        show: false,
        scope: $scope.$new()
    });

    let signInReturnPath = urlUtils.getQueryParams()['signIn'];
    if (!!signInReturnPath) {
        if (!securitySvc.isAuthenticated()) {
            signInDialogPromise.$promise.then(function () {
                signInDialogPromise.show();
            });
        } else {
            urlUtils.setUrlParam("signIn", null);
        }
    }
}]);